import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import LoadingScreen from "../LoadingScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const Reports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const email = state?.user?.emailId;
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [modulesList, setModulesList] = useState([]);
  const [selModule, setSelModule] = useState("");
  const [reportGoupList, setReportGroupList] = useState([]);
  const [selReportGroup, setSelReportGroup] = useState("");
  const [reportList, setReportList] = useState([]);
  const divisionState = useSelector((state) => state.changeDivision);
  const [userdivisionRights, setuserDivisionList] = useState([]);

  const [company, setCompany] = useState({});
  const [PopUpReport, setPopUpReport] = useState(false);
  const currentDate = new Date();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [division, setDivision] = useState("");

  const [showPopUp, setShowPopUp] = useState(false);
  const [validations, setValidations] = useState({});

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]);
      })
      .catch((err) => {
        console.log("Error While fetching Company Details", err);
      });

    axios
      // .get(`${BASEURL}/getdivisionRights?USEREMAIL=${email}`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=568&OM_USER_CODE=${email?.split("@")[0]}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        if (divisionState) {
          setuserDivisionList(response.data);
        } else {
          dispatch(setDivision(response?.data[0]?.OM_USER_DIVISION));
          setuserDivisionList(response.data);
        }
      })
      .catch((err) => {
        console.log("Error While fetching division rights", err);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1545&USEREMAIL=${email}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        const distinctData = Array.from(
          new Map(res?.data?.map((item) => [item.MODULE, item])).values(),
        );
        const distinctReportGroup = Array.from(
          new Map(res?.data?.map((item) => [item.REPORTGROUP, item])).values(),
        );
        setModulesList(distinctData);
        setReportGroupList(distinctReportGroup);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching Journey Data", err);
      });
  }

  function getReports(module, reportGroup) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1545&USEREMAIL=${email}&MODULE=${module}&REPORTGROUP=${reportGroup}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        setReportList(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching Journey Data", err);
      });
  }

  // Generate Report

  //               "DATERANGE": "Single Date",
  //            "CRNAME": "CrPeriodicCountrywiseLoadings.rpt",
  // "DATEBASED": true,
  // "DATERANGE": "Date Range",
  // "DIVISIONBASED": false,
  function generateReport(reportName) {
    setPdfData(null);
    setLoadingScreenBlock(true);

    axios
      .post(
        `${BASEURL}/generatereport`,
        {
          REPORTNAME: reportName,
          STARTDATE: startDate ? startDate : "",
          ENDDATE: endDate ? endDate : "",
          DIVISIONBASED: validations?.DIVISIONBASED === true ? "YES" : "NO",
          DIVISIONNAME:
            validations?.DIVISIONBASED === true ? divisionState : "",
          SINGLEMULTIDATE: validations?.DATERANGE ? validations?.DATERANGE : "",
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
          responseType: "blob", // Important for handling binary data
          timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        setLoadingScreenBlock(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="">
      <AllPagesNavbar/>
      <div className="lg:flex mt-3 lg:flex-col bg-gray-100 p-2 m-2 rounded-md">
        <div className="flex lg:mt-1 justify-between">
          <div className="flex gap-2">
            <Select
              className="w-96 lg:ml-2"
              value={
                selModule
                  ? { value: selModule, label: selModule }
                  : { value: "", label: "Select Module" }
              }
              onChange={(e) => {
                setSelModule(e.value);
                if (selReportGroup) {
                  getReports(e.value, selReportGroup);
                }
              }}
              options={[
                {
                  label: "Select Module",
                  value: "",
                },
                ...modulesList?.map((item) => ({
                  value: item?.MODULE,
                  label: item?.MODULE,
                })),
              ]}
            ></Select>
          </div>

          <div className="flex gap-2">
            <p className="lg:ml-2">Report Group :</p>
            <Select
              className="w-96 lg:ml-2"
              value={
                selReportGroup
                  ? { value: selReportGroup, label: selReportGroup }
                  : { value: "", label: "Select Report Group" }
              }
              onChange={(e) => {
                setSelReportGroup(e.value);
                if (selModule) {
                  getReports(selModule, e.value);
                }
              }}
              options={[
                {
                  label: "Select Report Group",
                  value: "",
                },
                ...reportGoupList?.map((item) => ({
                  value: item?.REPORTGROUP,
                  label: item?.REPORTGROUP,
                })),
              ]}
            ></Select>
          </div>
        </div>
      </div>

      <div className="visible lg:w-[400px] lg:h-[500px] p-5s z-0 lg:overflow-auto mt-2">

      <table className="w-full border border-gray-300 text-sm">
        <thead className="sticky top-0">
          <tr className="bg-[#2b3f5c] text-white text-[12px]">
            <td className="text-right">SNo</td>
            <td className="text-left">REPORT NAME</td>
          </tr>
        </thead>
        <tbody>
          {reportList?.map((row, index) => (
            <tr
              key={index}
              className="hover:bg-gray-100 cursor-pointer text-[13px]"
              onClick={async () => {
                setValidations(row);
                setShowPopUp(true);
              }}
            >
              <td className="border px-4 py-2 text-right">{index + 1}</td>
              <td className="border px-4 py-2">
                {row.REPORNAME ? row.REPORNAME : ""}
              </td>
            </tr>
          ))}
        </tbody>
        </table>
              </div>


      {showPopUp && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[300px] h-[80%] lg:w-[500px] w-[95%] p-1 overflow-y-auto z-[500]">
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Start Date:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={startDate?.split("T")[0]}
              onChange={(e) => setStartDate(e.target.value)}
            ></input>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">End Date:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={endDate?.split("T")[0]}
              onChange={(e) => setEndDate(e.target.value)}
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Division:</p>
            <select
              onChange={(e) => {
                dispatch(setDivision(e.target.value));
              }}
              className="w-48 h-6 border-black border ml-2 mr-2 rounded"
            >
              <option>{divisionState}</option>
              {userdivisionRights.map((item) =>
                item.OM_USER_DIVISION !== divisionState ? (
                  <option key={item.OM_USER_DIVISION} value={item.OM_USER_DIVISION}>
                    {item.OM_USER_DIVISION}
                  </option>
                ) : null,
              )}
            </select>
          </div>

          <button
            className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (validations?.DIVISIONBASED === true && !divisionState) {
                alert("Kindly supply division");
                return;
              }

              if (
                validations?.DATEBASED === true &&
                validations?.DATERANGE === "Single Date" &&
                !startDate
              ) {
                alert("Kindly Supply Start Date");
                return;
              }

              if (
                validations?.DATEBASED === true &&
                validations?.DATERANGE === "Date Range" &&
                (!startDate || !endDate)
              ) {
                alert("Kindly Supply Start Date & End Date");
                return;
              }

              setShowPopUp(false);
              setPopUpReport(true);
              await generateReport(validations?.CRNAME);
            }}
          >
            GET REPORT
          </button>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowPopUp(false)}
          >
            Close
          </button>
        </div>
      )}

      {/* Report View */}

      {PopUpReport && (
        <div>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 99,
            }}
          />

          {/* Popup */}
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              border: "1px solid black",
              height: "80%",
              width: "90%",
              maxWidth: "90%",
              maxHeight: "600px",
              padding: "16px",
              zIndex: 100,
              overflowY: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            {LoadingScreenBlock && <LoadingScreen />}
            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setPopUpReport(false)}
            >
              Close
            </button>
            <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
              <div>
                <section className="lg:hidden block">
                  {pdfData && (
                    <button
                      className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                      onClick={handleDownload}
                    >
                      Download PDF
                    </button>
                  )}
                </section>
                <section className="lg:block">
                  {pdfData ? (
                    <div className="mt-4">
                      <h2 className="text-lg font-bold">Generated Report</h2>
                      <iframe
                        src={pdfData}
                        title="Generated Report"
                        width="100%"
                        height="600px"
                      ></iframe>
                    </div>
                  ) : (
                    <p className="text-2xl font-bold my-4 text-center">
                      No report available.
                    </p>
                  )}
                </section>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
